import { AgGaugeOptions } from 'ag-charts-enterprise';
import { AG_CHARTS_LOCALE_FR_FR } from 'ag-charts-locale';
import { AgGauge } from 'ag-charts-react';
import React from 'react';
import { useTheme } from '../../hooks/useTheme';

interface GenericAgGaugeProps {
    options: AgGaugeOptions;
    className?: string;
    style?: React.CSSProperties;
}

const GenericAgGauge: React.FC<GenericAgGaugeProps> = ({ options, className, style }) => {
    const { agChartTheme } = useTheme();
    return (
        <div className={className} style={{ borderRadius: 10, overflow: 'hidden', ...style }}>
            <AgGauge
                options={{
                    theme: agChartTheme,
                    locale: {
                        localeText: AG_CHARTS_LOCALE_FR_FR,
                    },
                    background: {
                        visible: false,
                    },
                    ...options,
                }}
            />
        </div>
    );
};

export default GenericAgGauge;
